module.exports = {
    mongodb: 'mongodb://localhost/upsales-dashboard',
    mongodb_prod: 'mongodb://172.31.49.80/upsales-dashboard-production',
    mongodb_prod_beta: 'mongodb://172.31.49.80/upsales-dashboard',
    pusher: {
        id: '121591',
        key: '0353fe6711d017f94728',
        secret: '2e9dfcca75bacc79464c',
    },
};



/** WEBPACK FOOTER **
 ** ./config/config.js
 **/